import React from 'react';
import { Outlet } from 'react-router-dom';
import { TiktokShopProvider } from '@/tiktok-platform/context/TiktokShopContext';
import '@/styles/tiktok-platform/tiktok-platform.css';
import '@/styles/tiktok-platform/tiktok-product-ops.css';
import '@/styles/tiktok-platform/tiktok-notice-help.css';

/**
 * 通知帮助中心独立布局：无 TikTok 顶栏、无左侧菜单；内容铺满整页。
 */
export default function TiktokStandaloneHelpLayout() {
  return (
    <TiktokShopProvider>
      <div className="tiktok-help-standalone" data-testid="tiktok-standalone-help-layout">
        <Outlet />
      </div>
    </TiktokShopProvider>
  );
}
